// extracted by css-extract-rspack-plugin
export default {"fallback":"dyBiD2Y7IYQrmU5f","visual":"VhlUrDEz0b8Ui7uj","pulse":"PQMaQXPRQ2wyT6O_","text":"T_clgPE1kIs5djyq"};